module.exports = __webpack_public_path__ + "img/img-register-portada.9e2ddc18.png";